import { DialogTitle, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CloseDialogButton from './CloseDialogButton'

interface IProps {
    text?: string
    onClose?: () => void
}

export default function AppDialogTitle({ text, onClose }: IProps) {
    const { t } = useTranslation()

    return (
        <DialogTitle
            sx={{
                m: 0,
                px: (theme) => theme.spacing(3),
                py: (theme) => theme.spacing(2),
                bgcolor: 'topside.main',
                ...(!text && {
                    bgColor: 'topside.contrastText',
                    mb: (theme) => theme.spacing(0),
                }),
            }}
        >
            <Typography variant="body1">
                {t(text || '') || <span>&nbsp;</span>}
            </Typography>
            {onClose && <CloseDialogButton onClick={onClose} />}
        </DialogTitle>
    )
}
